import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/ui/sidebar-boundary/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazySidebarContent = lazyForPaint(() =>
	import(
		/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebar-content" */ './index'
	).then(({ SidebarContent }) => SidebarContent),
);

const AsyncSidebarContent = memo(() => (
	<SidebarBoundary
		id="asyncSidebarContent"
		packageName="jiraNavigationAppsSidebarNav4SidebarContent"
		teamName="jira-cosmos"
	>
		<Placeholder name="lazySidebarContent">
			<LazySidebarContent />
		</Placeholder>
	</SidebarBoundary>
));

AsyncSidebarContent.displayName = 'AsyncSidebarContent';

// Used in jira/src/packages/page-container-v2/src/common/ui/sidebar
export default AsyncSidebarContent;
